export const TRIAL_EMAIL_STORAGE_KEY = 'trialEmail';
export const TRIAL_RESOURCE_TYPE_STORAGE_KEY = 'trialResourceType';
export const TRIAL_RESOURCE_KEY_STORAGE_KEY = 'trialResourceKey';
export const TRIAL_IS_BEEKEEPER = 'isBeekeeper';
